(function () {
  var form = document.querySelector('[data-qualifier-form]');
  if (!form) return;

  var submitBtn = form.querySelector('[data-submit]');
  var submitError = form.querySelector('[data-submit-error]');
  var confirmation = document.querySelector('[data-confirmation]');

  var params = new URLSearchParams(window.location.search);
  if (params.get('name')) form.elements.name.value = params.get('name');
  if (params.get('email')) form.elements.email.value = params.get('email');

  // Turnstile, rendered explicitly so the token arrives on a callback rather
  // than being polled for. A visitor can submit before the token lands, so
  // waitForToken resolves the moment it does instead of failing the attempt.
  var turnstileKey = form.getAttribute('data-turnstile-key');
  var turnstileToken = '';
  var tokenWaiters = [];

  function deliverToken(token) {
    turnstileToken = token || '';
    var waiting = tokenWaiters;
    tokenWaiters = [];
    waiting.forEach(function (resolve) { resolve(turnstileToken); });
  }

  if (turnstileKey) {
    var slot = form.querySelector('[data-turnstile-slot]');
    var s = document.createElement('script');
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    s.async = true;
    s.onload = function () {
      if (!window.turnstile) return;
      window.turnstile.render(slot, {
        sitekey: turnstileKey,
        callback: deliverToken,
        'expired-callback': function () { turnstileToken = ''; },
        'error-callback': function () { deliverToken(''); }
      });
    };
    document.head.appendChild(s);
  }

  function waitForToken(maxMs) {
    if (!turnstileKey) return Promise.resolve('');
    if (turnstileToken) return Promise.resolve(turnstileToken);
    return new Promise(function (resolve) {
      var settled = false;
      function finish(token) {
        if (settled) return;
        settled = true;
        resolve(token || '');
      }
      tokenWaiters.push(finish);
      setTimeout(function () { finish(''); }, maxMs);
    });
  }

  function showError(key, field, show) {
    var el = form.querySelector('[data-error-for="' + key + '"]');
    if (el) el.hidden = !show;
    if (field && field.setAttribute) {
      if (show) {
        field.setAttribute('aria-invalid', 'true');
      } else {
        field.removeAttribute('aria-invalid');
      }
    }
  }

  function checked(name) {
    return Array.prototype.slice
      .call(form.querySelectorAll('input[name="' + name + '"]:checked'))
      .map(function (el) { return el.value; });
  }

  function radioValue(name) {
    var el = form.querySelector('input[name="' + name + '"]:checked');
    return el ? el.value : '';
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    var name = form.elements.name.value.trim();
    var email = form.elements.email.value.trim();
    var guiding = radioValue('guiding_level');
    var nameOk = name !== '';
    var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    var guidingOk = guiding !== '';
    showError('name', form.elements.name, !nameOk);
    showError('email', form.elements.email, !emailOk);
    showError('guiding', null, !guidingOk);
    if (!nameOk) { form.elements.name.focus(); return; }
    if (!emailOk) { form.elements.email.focus(); return; }
    if (!guidingOk) { form.querySelector('input[name="guiding_level"]').focus(); return; }

    submitError.hidden = true;
    submitBtn.disabled = true;
    var restoreLabel = submitBtn.textContent;
    if (turnstileKey && !turnstileToken) submitBtn.textContent = submitBtn.getAttribute('data-sending-label') || restoreLabel;

    var payload = {
      form_type: 'qualifier',
      name: name,
      email: email,
      guiding_level: guiding,
      first_visit: radioValue('first_visit'),
      landmarks: form.elements.landmarks.value.trim(),
      interests: checked('interests'),
      interests_other: form.elements.interests_other.value.trim(),
      food_preferences: form.elements.food_preferences.value.trim(),
      dietary_requirements: form.elements.dietary_requirements.value.trim(),
      shopping: form.elements.shopping.value.trim(),
      pace: radioValue('pace'),
      walking: radioValue('walking'),
      walking_notes: form.elements.walking_notes.value.trim(),
      reservations: form.elements.reservations.value.trim(),
      must_avoid: form.elements.must_avoid.value.trim(),
      food_importance: radioValue('food_importance'),
      cultural: checked('cultural'),
      occasion: radioValue('occasion'),
      occasion_other: form.elements.occasion_other.value.trim(),
      hotels_status: radioValue('hotels_status'),
      hotels_names: form.elements.hotels_names.value.trim(),
      website: form.elements.website.value,
      page: window.location.href
    };

    waitForToken(20000)
      .then(function (token) {
        payload.turnstile_token = token;
        return fetch(form.action, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('bad status ' + res.status);
        return res.json();
      })
      .then(function () {
        form.hidden = true;
        confirmation.hidden = false;
        confirmation.focus();
      })
      .catch(function () {
        submitError.hidden = false;
        submitBtn.disabled = false;
        submitBtn.textContent = restoreLabel;
      });
  });
})();
